import React from 'react';
import _ from 'lodash';
import slugify from 'slugify';

import { TableData, TableRow } from '~components/common/Table';
import { HTMLContent } from '~components/Content';
import { rowRendererProps } from '../propTypes';
import { RowDataRenderer } from './default';

export default function VoterIdLawsAbsentee({ state }) {
  const stateName = state.fieldValue;
  const stateSlug = slugify(stateName.toLowerCase());
  const stateData = _.keyBy(state.nodes, 'field_type');

  // using this format to populate data to avoid errors when compiling locally
  const idAbsenteeRequest = stateData.id_laws_absentee_request
    ? stateData.id_laws_absentee_request.html
    : 'N/A';
  const idAbsenteeReturn = stateData.id_laws_ballot_return
    ? stateData.id_laws_ballot_return.html
    : 'N/A';

  return (
    <TableRow>
      <TableData>
        <a
          href={`/absentee-mail-ballot/${stateSlug}/`}
          title={`Request your ballot in ${stateName}`}
        >
          {stateName}
        </a>
      </TableData>
      <RowDataRenderer
        columns={[
          {
            title: 'ID needed for absentee ballot request',
            valueNode: (
              <HTMLContent content={idAbsenteeRequest} className='space-y-3' />
            ),
          },
          {
            title: 'ID needed for absentee ballot return',
            valueNode: (
              <HTMLContent content={idAbsenteeReturn} className='space-y-3' />
            ),
          },
        ]}
      />
    </TableRow>
  );
}

VoterIdLawsAbsentee.propTypes = rowRendererProps;
